import React from "react";
import { FaLocationArrow } from "react-icons/fa6";

const VenueIcon = () => <FaLocationArrow color='#96A4CB' />;

export default VenueIcon;